const API_URL =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'entregashm.adasistemas.com.br'
    ? 'https://sistema.altinfo.com.br/entregas'
    : 'https://aws.adasistemas.com.br/entregas');
const API_APP = '17d25d4e32a8eb91d897358fc01ddd7c';

const getAuthHeaders = () => {
  const token = localStorage.getItem('acessToken');
  return {
    'Content-Type': 'application/json',
    app: API_APP,
    access: token || '',
  };
};

const handleApiError = async (response: Response, defaultMessage: string) => {
  if (!response.ok) {
    try {
      const errorData = await response.json();
      if (errorData && errorData.message) {
        throw new Error(errorData.message);
      } else if (errorData && errorData.error) {
        throw new Error(errorData.error);
      } else {
        throw new Error(defaultMessage);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error(
        `${defaultMessage} (${response.status}: ${response.statusText})`
      );
    }
  }
};

export const API_ROUTERS = {
  USUARIO: 'api/usuario',
  OCORRENCIA: 'api/ocorrencia',
  GRUPO_USUARIO: 'credenciais/grupoUsuario',
  NOTA: 'api/nota',
  ENTREGADORES: 'credenciais/usuario/entregador',
  RELATORIO: 'api/relatorio',
  RELATORIOS_ENTREGADORES: 'api/relatorio-entregador',
  DESPESA: 'api/despesa',
  DESPESA_CATEGORIA: 'api/despesa-categoria',
};

export const api = {
  host: API_URL,
  auth: {
    login: async (email: string, password: string, empresa: string) => {
      const response = await fetch(`${API_URL}/credenciais/autenticacao`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          app: API_APP,
        },
        body: JSON.stringify({
          empresa: empresa.toLowerCase(),
          login: email.toLowerCase(),
          senha: password,
        }),
      });

      await handleApiError(response, 'Falha na autenticação');
      const accessToken = response.headers.get('access');
      if (!accessToken) throw new Error('Falha na autenticação');
      return {
        user: (await response.json()) || {},
        token: accessToken,
      };
    },

    trocarSenha: async (empresa: string, login: string) => {
      const response = await fetch(
        `${API_URL}/credenciais/autenticacao?esqueciSenha=true`,
        {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify({
            empresa: empresa.toLowerCase(),
            login: login.toLowerCase(),
          }),
        }
      );

      await handleApiError(response, 'Falha ao solicitar redefinição de senha');

      return response.json();
    },
  },

  get: async (router: string, id: string = '') => {
    try {
      const response = await fetch(
        `${API_URL}/${router}${id == '' ? '' : `/${id}`}`,
        {
          method: 'GET',
          headers: getAuthHeaders(),
        }
      );

      await handleApiError(response, 'Falha ao salvar usuário');

      return response.json();
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error(
        'Erro ao conectar com o servidor. Verifique sua conexão.'
      );
    }
  },

  post: async (router: string, body: object) => {
    try {
      const response = await fetch(`${API_URL}/${router}`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(body),
      });

      await handleApiError(response, 'Falha ao salvar usuário');

      return response.json();
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error(
        'Erro ao conectar com o servidor. Verifique sua conexão.'
      );
    }
  },

  put: async (router: string, body: object) => {
    try {
      const response = await fetch(`${API_URL}/${router}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(body),
      });

      await handleApiError(response, 'Falha ao atualizar registro');

      return response.json();
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error(
        'Erro ao conectar com o servidor. Verifique sua conexão.'
      );
    }
  },

  delete: async (router: string, id: string = '') => {
    try {
      const response = await fetch(
        `${API_URL}/${router}${id == '' ? '' : `/${id}`}`,
        {
          method: 'DELETE',
          headers: getAuthHeaders(),
        }
      );
      if (!response.ok) {
        throw new Error('Erro ao executar requisição');
      }
      return response;
    } catch (error) {
      console.error('Erro na requisição DELETE:', error);
      throw error;
    }
  },

  utils: {
    trataResponseArray: (
      response: any,
      mapFunction?: (item: any) => any
    ): object => {
      if (Array.isArray(response)) {
        return response.map(mapFunction || ((item) => item));
      }
      if (response && Array.isArray(response.data)) {
        return response.data;
      }
      if (response && typeof response === 'object') {
        return Object.values(response).find((val) => Array.isArray(val)) || [];
      }
      return [];
    },
  },
};
